import { render, staticRenderFns } from "./new-db-page.vue?vue&type=template&id=247fe844"
import script from "./new-db-page.vue?vue&type=script&lang=js"
export * from "./new-db-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports